import { render, staticRenderFns } from "./messageList.vue?vue&type=template&id=a9bf8a7e&scoped=true"
import script from "./messageList.vue?vue&type=script&lang=js"
export * from "./messageList.vue?vue&type=script&lang=js"
import style0 from "./messageList.vue?vue&type=style&index=0&id=a9bf8a7e&prod&lang=scss&scoped=true"
import style1 from "./messageList.vue?vue&type=style&index=1&id=a9bf8a7e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9bf8a7e",
  null
  
)

export default component.exports